import React, { useState } from "react";
import {
  Container,
  Title,
  Input,
  Textarea,
  Button,
} from "../../library/components";

const Contact = () => {
  const [values, setValues] = useState({
    email: "",
    subject: "",
    content: "",
  });

  const sendEmail = () => {
    // fetch(`https://tirxpwl3b0.execute-api.us-east-1.amazonaws.com/prod`, {
    //     method: 'POST',
    //     headers: {
    //         'x-api-key': 'MBH9CqI3Pa6lBDxQhxHvN9rpdmzrbGp158oN1V3I',
    //         'Content-type': 'application/json'
    //     },
    //     body: JSON.stringify({...values})
    // })
    //     .then(() => {
    //         setValues({
    //             email: '',
    //             subject: '',
    //             content: ''
    //         })
    //     })
  };

  return (
    <div style={{ margin: "4rem 0" }}>
      <Container>
        <Title size="22px" color="#008AD7">
          Contactános
        </Title>
        <Title size="56px" className="m-none" color="#2B292D">
          Trabajá con nosotros
        </Title>
        <Title size="42px" className="m-display" color="#2B292D" align="center">
          Trabajá con nosotros
        </Title>
        <div
          className="m-cont"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: "50%",
          }}
        >
          <Title size="16px" align="left">
            Tú Email
          </Title>
          <Input
            value={values.email}
            onChange={(e) => setValues({ ...values, email: e.target.value })}
            placeholder="nombre@mail.com"
            type="text"
          />
          <br />
          <Title size="16px" align="left">
            Asunto
          </Title>
          <Input
            value={values.subject}
            onChange={(e) => setValues({ ...values, subject: e.target.value })}
            placeholder="Consulta"
            type="text"
          />
          <br />
          <Title size="16px" align="left">
            Mensaje
          </Title>
          <Textarea
            value={values.content}
            onChange={(e) => setValues({ ...values, content: e.target.value })}
            placeholder="Mensaje"
          />
        </div>
        <Button
          width="100%"
          style={{ margin: "1rem 0" }}
          onClick={() => sendEmail()}
          primary
        >
          Enviar Mensaje
        </Button>
      </Container>
    </div>
  );
};

export default Contact;
